//
// Copyright (c) 2011-2017 by Curalate, Inc.
//

(function() {
    //
    // This service is meant to be a convenience and standardization wrapper for the ToastNoficiationService
    // It bakes in default options that should be most commonly used by new Toasts in our UI.
    //
  angular.module('curalate').service('MinimalToastNotificationService', [
    '$templateCache',
    'ToastNotificationService',
    function(
            $templateCache,
            ToastNotificationService,
        ) {
      const MinimalToastNotificationService = this;
      const iconsByType = {
        error: 'di di-attention-13px',
        success: 'di di-approved-16px',
      };

      const defaultOptions = {
        closeButton: true,
        tapToDismiss: false,
        toastTemplate: 'directives/toast/minimal.html',
      };

            // Additional options we like to use for toasts that should stick around.
      const stickyToastOptions = angular.extend({}, defaultOptions, {
        timeOut: 0,
        extendedTimeOut: 0,
      });

      $templateCache.put(defaultOptions.toastTemplate,
                '<div ng-class="{\'toast-clickable\': !!options.tapToDismiss, \'toast-autodismiss\': !!options.timeOut }" ' +
                     'class="toast-notification {{::toastType}} toast-clean toast-cleaner clearfix" ng-click="tapToast()">' +
                    '<div class="tn-message" ng-switch="::allowHtml">' +
                        '<strong ng-switch-default class="toast-title" ng-if="title"><i class="{{::options.customIconClass}}"></i>&nbsp; {{title}}</strong>' +
                        '<div ng-switch-default class="toast-message">{{message}}</div>' +
                        '<div ng-switch-when="true" class="toast-title" ng-if="::title" ng-bind-html="::title"></div>' +
                        '<div ng-switch-when="true" class="toast-message" ng-bind-html="message"></div>' +
                    '</div>' +
                '</div>',
            );

      this.stickyToast = {};

            // Methods which will have extra parameters piped in for Minimal Toasts
      ['error', 'success', 'warning', 'info'].forEach((method) => {
        MinimalToastNotificationService[method] = function(args) {
          args = args || {};
          args.options = angular.extend({}, defaultOptions, {
            customIconClass: iconsByType[method],
          });
          ToastNotificationService[method](args);
        };
        MinimalToastNotificationService.stickyToast[method] = function(args) {
          args = args || {};
          args.options = angular.extend({}, stickyToastOptions, {
            customIconClass: iconsByType[method],
          });
          ToastNotificationService[method](args);
        };
      });

            // Direct passthrough methods
      ['close', 'updateMessage', 'updateOptions'].forEach((method) => {
        MinimalToastNotificationService[method] = ToastNotificationService[method].bind(ToastNotificationService);
      });
    }]);
})();
